import React, { useState } from 'react';
import { FDBox, FDStack, FDPrimaryActionButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { relationshipType } from 'facet-rest/src/consts/relationships';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { navigateTo } from 'Helpers/Redirect';
import { dashboardWithModal } from 'Consts/clientUris';

const ResponseButtons = ({
  innerMessageResponseResource,
  handleMessageResponse,
}) => {
  const [loading, setLoading] = useState(undefined);
  const { displayErrorMessage } = useSnackbarContext();
  const canPost = innerMessageResponseResource.meta().action('POST');
  const canPut = innerMessageResponseResource.meta().action('PUT');
  const cannotRespond = (!canPost && !canPut) || !!loading;
  const { loadPageContentLink } = usePageContentContext();

  const supportedRelationshipTypes = [
    relationshipType.responseButton,
    relationshipType.linkButton,
    relationshipType.schedulerButton,
  ];

  const innerMessageResponseResourceRelationshipList = innerMessageResponseResource.relationships().list().filter(link => {
    return supportedRelationshipTypes.includes(link.meta('relationshipType'));
  });
  const relationshipsInListThatHaveLabels = innerMessageResponseResourceRelationshipList.filter(link => link.meta('prompt') !== '');


  const handleResponseButtonClick = async (event, relationship) => {
    // Set loading to the relationship name so the correct button shows the loading indicator.
    setLoading(relationship.attr('name'));
    try {
      await handleMessageResponse(event, relationship);
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Error: Failed to update record response. Please contact support if this issue persists');
      }
    }
    setLoading(undefined);
  };


  const onClick = async (event, relationship) => {
    if (!supportedRelationshipTypes.includes(relationship.meta('relationshipType'))) {
      throw new Error(`Unsupported relationship type: ${relationship.meta('relationshipType')}`);
    }
    switch (relationship.meta('relationshipType')) {
      case relationshipType.responseButton:
        await handleResponseButtonClick(event, relationship);
        return;
      case relationshipType.linkButton:
        await loadPageContentLink(relationship.link('related'));
        return;
      case relationshipType.schedulerButton:
        navigateTo(
          dashboardWithModal('clientSchedulerModal', {
            link: relationship
              .link('related')
              .url(),
          }),
        );
        return;
      default:
        throw new Error(`Unknown relationship type: ${relationship.meta('relationshipType')}`);
    }
  };

  // If there are no labels for any of the buttons, the buttons should not appear.
  const noLabels = innerMessageResponseResourceRelationshipList.length !== relationshipsInListThatHaveLabels.length;
  if (noLabels) {
    return null;
  }

  return (
    <FDBox padding={100}>
      <FDStack direction={'row'} spacing={2} wrap>
        {
          innerMessageResponseResourceRelationshipList.map((relationship) => {
            return (
              <FDPrimaryActionButton
                key={relationship.attr('name')}
                loading={loading === relationship.attr('name')}
                disabled={cannotRespond}
                label={relationship.meta('prompt')}
                onClick={(event) => onClick(event, relationship)}
              />
            );
          })
         }
      </FDStack>
    </FDBox>
  );
};

ResponseButtons.defaultProps = {
};

ResponseButtons.propTypes = {
  innerMessageResponseResource: PropTypes.object.isRequired,
  handleMessageResponse: PropTypes.func.isRequired,
};

export default ResponseButtons;
